import { Component, ElementRef, HostListener, Injector, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { INewsUpdateRequest, NewsBlogsService } from '../../services/news-blogs.service';
import { TranslationService } from '../../services/translation.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { SettingService } from '../../services/setting.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  standalone: false
})
export class NewsComponent  implements OnInit {

  merchantId: string;
  news: any;
  dayData: any;

  updateNewsRequest: INewsUpdateRequest;

  availableHoursString: string;

  mobile: boolean = false;

  homersLayout: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private newsBlogService: NewsBlogsService,
    public translationService: TranslationService,
    private injector: Injector,
    public authservice: AuthService,
    public settings: SettingService,
    private element: ElementRef
  ) { }

  ngOnInit() {

    // Only access NavParams if running inside a modal
    const navParams = this.injector.get(NavParams, null);
    try {
      if(navParams.get('blog') != undefined) {
        this.news = navParams.get('news');
      }
      if(navParams.get('dayData') != undefined) {
        this.dayData = navParams.get('dayData');
      }
      if(navParams.get('merchantId') != undefined) {
        this.merchantId = navParams.get('merchantId');
      }

      // double check if it works with multiple time later
      if(this.news.dailyShowcase) {
        for(var i = 0; i < this.news.dailyShowcase.length; i++) {
          var day = this.news.dailyShowcase[i];
          if(this.dayData) {
            if (day.dayID.includes(this.dayData.value)) {
              if(day.hoursRange?.startHours && day.hoursRange?.endHours) {
                if(this.availableHoursString) {
                  if(this.translationService.getLanguage() == "fr") {
                    this.availableHoursString = this.availableHoursString + "De " + day.hoursRange.startHours + " a " + day.hoursRange.endHours;
                  } else {
                    this.availableHoursString = this.availableHoursString + "From " + day.hoursRange.startHours + " to " + day.hoursRange.endHours;
                  }
                  
                } else {
                  if(this.translationService.getLanguage() == "fr") {
                    this.availableHoursString = "De " + day.hoursRange.startHours + " a " + day.hoursRange.endHours;
                  } else {
                    this.availableHoursString = "From " + day.hoursRange.startHours + " to " + day.hoursRange.endHours;
                  }
                  
                }
              }
              
            }
          }
        }
      }
      

      /*
      console.log(this.news.dailyShowcase);

      console.log(this.news);
      console.log(this.dayData);
      */
    } catch (e) {
      //console.log(e);

      this.closePopup();
    }

    const hostElement = this.element.nativeElement;
    const host = hostElement;
    host.style.setProperty('--btn-color', this.news.btnColor);
    host.style.setProperty('--btn-txt-color', this.news.btnTextColor);


    if (window.innerWidth <= 500) {
      this.mobile = true; 
    } else {
      this.mobile = false;
    }

    if(this.settings.configuration.uIoptions && this.settings.configuration.homePageConfiguration != null && this.settings.configuration.uIoptions?.homePageOption == 10) {
      this.homersLayout = true;
    } else {
      this.homersLayout = false;
    }
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 
    if (window.innerWidth <= 500) { 
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  UseLink() {
    // use the link that is in 
    //this.blog.btnLink.translations[this.translationService.getLanguage()]
  }

  getnewsImage(){
    //smaImage
    if (this.news.images.imgShortName == null && this.news.images.imgDisplayName) {
      const urlPath = this.news.images.imgDisplayName;
      return "https://seemyapps.com" + urlPath;
    } else {
      //SMS image
      if(this.news.images){
        if(this.news.images.imgURL) {
          const url = this.news.images.imgURL;
          return url;
        }     
      }
    }
  }

  textDisplay(text, lang) {
    const fallbackLang = lang === 'en' ? 'fr' : 'en';

    return text.translations[lang] ?? text.translations[fallbackLang];
  }

  formatDate(date: any): string {

    if (!date) {
      return '';
    }

    if (typeof date === 'string') {
      return date.split('T')[0];
    }

    return new Date(date).toISOString().split('T')[0];
  }


  deletenews() {
    // delete the specified news passing through
    
    this.deleteNews(this.news).subscribe(async completedDeletion => {
      if(completedDeletion) {
        this.modalCtrl.dismiss("deleted");
      }
    });
  }

  deleteNews(news) {
    this.updateNewsRequest = {
      merchantId: this.merchantId,
      userId: this.authservice.memberId.toString(),
      newsId: news.id,
      status: "deleted"
    }

    return this.newsBlogService.updateNews(this.updateNewsRequest);
  }

  closePopup(){
    //if(this.isPopup) {
      this.modalCtrl.dismiss();
    //}
  }
}
